import { render } from "./TextSeparator.vue?vue&type=template&id=b4006628&scoped=true"
const script = {}

import "./TextSeparator.vue?vue&type=style&index=0&id=b4006628&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4006628"]])

export default __exports__